/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clock': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12 6A6 6 0 110 6a6 6 0 0112 0zM6 2H5v4.27l3.217 2.252.574-.82L6 5.75V2z" _fill="#2E5C78"/>'
  }
})
